import React from "react";

const WalletTableSkeleton = () => {
  const rows = 10;

  return (
    <>
   
      <div className="wallett-balance">
        <div className="wallett-balance-title">
          <div className="token-toggle">
            <label className="skeleton skeleton-radio-label" />
            <label className="skeleton skeleton-radio-label" />
          </div>
        </div>

        <div className="wallett-balance-amount">
          <span className="skeleton skeleton-text" style={{ width: "120px", height: "20px" }} />
          
        </div>
      </div>

      {/* Skeleton for Token Table */}
      <div className="wallett-tokens">
        <table className="wallett-table">
          <thead>
            <tr>
              <th className="wallett-table-header">Tokens</th>
              <th className="wallett-table-header">Balance</th>
              <th className="wallett-table-header">Change</th>
              <th className="wallett-table-header">Price</th>
            </tr>
          </thead>
          <tbody>
            {[...Array(rows)].map((_, idx) => (
              <tr key={idx}>
                <td className="wallett-token">
                  <div className="skeleton-token">
                    <div className="skeleton skeleton-circle" />
                    <div className="skeleton skeleton-text" style={{ width: "60%" }} />
                  </div>
                </td>
                <td>
                  <div className="skeleton skeleton-text" style={{ width: "70%" }} />
                  <div className="skeleton skeleton-text" style={{ width: "40%" }} />
                </td>
                <td>
                  <div className="skeleton skeleton-text" style={{ width: "50%" }} />
                </td>
                <td>
                  <div className="skeleton skeleton-text" style={{ width: "50%" }} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default WalletTableSkeleton;
